import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useT } from 'talkr';
import { Link } from 'react-router-dom';
import MenuButton from '../menuButton';
import s from './index.module.scss';

function Menu() {
	const firstLink = useRef(null);
	const dispatch = useDispatch();
	const { T } = useT();
	const menuOpened = useSelector(state => state.global.menuOpened);
	const stateClass = menuOpened ? s.opened : '';
	const disableFromFocus = !menuOpened ? -1 : '';

	function onClickAction() {
		document.querySelector('#root').scrollTo(0, 0);

		dispatch({
			type: 'TOGGLE_MENU',
			payload: false,
		});
	}

	useEffect(() => {
		window.addEventListener('popstate', () => {
			onClickAction();
		});
	}, []);

	useEffect(() => {
		if (menuOpened) {
			firstLink.current.focus();
		}
	}, [menuOpened]);

	return (
		<nav className={`${s.menu} ${stateClass}`}>
			<div className={s.menuWrapper}>
				<MenuButton disableFromFocus={disableFromFocus} />
			</div>
			<ul className={s.menuContent}>
				<li className={s.menuItem}>
					<Link tabIndex={disableFromFocus} onClick={onClickAction} to="/" ref={firstLink}>
						{T('menu_home')}
					</Link>
				</li>
				<li className={s.menuItem}>
					<Link tabIndex={disableFromFocus} onClick={onClickAction} to="/contacts">
						{T('menu_contacts')}
					</Link>
				</li>
				<li className={s.menuItem}>
					<a tabIndex={disableFromFocus} href="https://verv.com/web-privacy-policy/" target="_blank" rel="noreferrer">
						{T('menu_policy')}
					</a>
				</li>
				<li className={s.menuItem}>
					<a tabIndex={disableFromFocus} href="https://verv.com/terms-conditions/" target="_blank" rel="noreferrer">
						{T('menu_terms')}
					</a>
				</li>
			</ul>
			<div className={s.closeArea} onClick={onClickAction} />
		</nav>
	);
}

export default Menu;
